/* eslint-disable eqeqeq */
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FbPixelService } from 'src/app/core/services/fb-pixel.service';
import { MetaService } from 'src/app/core/services/meta.service';
import { register } from 'swiper/element/bundle';
import { environment } from 'src/environments/environment';
import { GARoute, GAScreen } from './core/enums/google-analytics-screens.enum';
import { GoogleAnalyticService } from './core/services/analytics.service';
import { SHOWTIME_BY_MOVIES_URL } from './core/constants/app.constants';
import { StorageService } from './core/services/storage.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit {
    title = 'GoldenScreenCinemas';
    isRendered = false;
    isGp = environment.isGp;

    constructor(
        public translate: TranslateService,
        private metaService: MetaService,
        private router: Router,
        private route: ActivatedRoute,
        private fbPixelService: FbPixelService,
        @Inject(PLATFORM_ID) private platform: Record<string, unknown>,
        private analyticsService: GoogleAnalyticService,
        private viewportScroller: ViewportScroller,
        private storageService: StorageService,
    ) {
        if (isPlatformBrowser(this.platform)) {
            const path = window.location.pathname;

            if (path === '/events') {
                window.location.href = 'https://www.gsc.com.my/promotions/gsc';
            }
            if (path === '/challenges') {
                window.location.href = '/';
            }
        }

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                if (event.urlAfterRedirects && !event.urlAfterRedirects.includes(GARoute.Review_Summary)) {
                    this.analyticsService.googleAnalyticsService.pageView(
                        event.urlAfterRedirects,
                        this.getTitle(event.urlAfterRedirects),
                    );
                }
                if (isPlatformBrowser(this.platform)) {
                    const activatedRoute = this.getChild(this.route);
                    activatedRoute.data.subscribe((data) => {
                        if (!data.isChangeMeta) {
                            this.metaService.resetMetaTag();
                        }
                    });
                }

                if (!event.url.includes(SHOWTIME_BY_MOVIES_URL)) {
                    this.viewportScroller.scrollToPosition([0, 0]);
                }
            }
        });

        if (isPlatformBrowser(this.platform)) {
            this.isRendered = true;
                if (this.isGp) {
                if (this.storageService.userMembershipInfo != null) {
                    localStorage.clear();
                    sessionStorage.clear();
                }
            } else if (!this.isGp && this.storageService.guestData != null) {
                localStorage.clear();
                sessionStorage.clear();
            }
        }
    }

    ngOnInit() {
        this.initLanguage();
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platform)) {
            register();
            this.fbPixelService.initialize();
        }
    }

    getTitle(currentRoute: string) {
        const route = currentRoute.substring(1);
        const value = Object.values(GARoute).filter((e) => e == route)[0];
        const key = Object.keys(GARoute)[Object.values(GARoute).indexOf(value)];
        return GAScreen[key as keyof typeof GAScreen];
    }

    private getChild(activatedRoute: ActivatedRoute): ActivatedRoute {
        if (activatedRoute.firstChild) {
            return this.getChild(activatedRoute.firstChild);
        }
        return activatedRoute;
    }

    private initLanguage(): void {
        this.translate.addLangs(['en-US']);
        this.translate.setDefaultLang('en-US');
    }
}
